export default "__VITE_ASSET__CAspv6sX__"